// vuex的专门用的获取state属性
import state from "./state";

export const accountStorage = state => state.account




// WEBPACK FOOTER //
// ./src/store/user/getters.js